/*// import ScrollOut
import ScrollOut from "scroll-out";

// Fade Up Effect Animation on any item with the .fadeinup class
ScrollOut({
    //targets:'.home #full-width-page-wrapper .wp-block-columns',
    //targets:'.fadeinup',
    targets: '.home #full-width-page-wrapper .wp-block-column:has(hr), .home #full-width-page-wrapper .wp-block-columns .wp-block-column:first-child:has(ul)',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInUp');
        // force reflow
        void el.offsetWidth;
        // re-add the animated cl
        el.classList.add('animate__animated', 'animate__fadeInUp');
        //el.animate([{ opacity: 0 }, { opacity: 1 }], 1000);
    }
});
// Fade Right Effect Animation on any item with the .fadeinright class
ScrollOut({
    //targets:'.home #full-width-page-wrapper .wp-block-columns',
    //targets:'.fadeinright',
    targets: '.home #full-width-page-wrapper .wp-block-columns .wp-block-column:last-child:has(h2, .wp-block-buttons)',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInRight');
        // force reflow
        void el.offsetWidth;
        // re-add the animated cl
        el.classList.add('animate__animated', 'animate__fadeInRight');
    }
});*/
//
import Lightbox from './bs5-lightbox';

const options = {
    keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => el.addEventListener('click', (e) => {
    e.preventDefault();
    const lightbox = new Lightbox(el, options);
    lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    slidesPerView: 1,
    // breakpoints: {
    //     992: {
    //         slidesPerView: 2,
    //         spaceBetween: 24
    //     }
    // },
    // autoHeight: true, // Make slides equal height
    // autoplay: {
    //     delay: 10000,
    // },
    // Navigation arrows
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
});
//
// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};
//
function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
        //
        //document.querySelector('.custom-logo-link').classList.remove('logo-hidden');
        document.querySelector('.navbar').classList.add('background');
    }
    else {
        mybutton.style.display = "none";
        document.querySelector('.navbar').classList.remove('background');
    }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}
//
document.addEventListener('DOMContentLoaded', () => {
    //const element = document.querySelector('.wp-image-123');
    const videoOverlay = '.wp-block-cover:has(.wp-block-cover__video-background) .wp-block-image img';
    const element = document.querySelector(videoOverlay);
    //
    if (element) {
        const logo = document.querySelector('.custom-logo-link');
        const initialWidth = element.offsetWidth;
        const isDesktop = window.matchMedia('(min-width: 992px)').matches;
        //alert(isDesktop);
        //const minWidth = isDesktop ? 130 : 120;
        const minWidth = isDesktop ? 200 : 120;
        //alert(minWidth);
        //const elementOffsetTop = isDesktop ? element.offsetTop - 15 : element.offsetTop - 9;
        const elementOffsetTop = isDesktop ? element.getBoundingClientRect().top + window.scrollY - 15 : element.getBoundingClientRect().top + window.scrollY - 9;
        //const elementOffsetTop = 480;
        const difference = initialWidth - minWidth;
        const perPixel = difference / elementOffsetTop;
        const updateSize = () => {
            const distanceScrolled = Math.max(0, elementOffsetTop - window.scrollY);
            const h = initialWidth - (window.scrollY * perPixel);
            console.table({ h: h, perPixel: perPixel, scrollY: window.scrollY, elementOffsetTop: elementOffsetTop, distanceScrolled: distanceScrolled });
            logo.classList.toggle('logo-hidden', distanceScrolled !== 0);
            element.classList.toggle('d-none', distanceScrolled === 0)
            const newHeight = Math.max(minWidth, h);
            element.style.width = `${newHeight}px`;
        }
        window.addEventListener('scroll', updateSize);
        window.addEventListener('load', updateSize);
    }
});